export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12070.d2aa4762.jpg";